import { PredefinedFilter } from 'src/app/models/predefined-filter';

export enum PredefinedFilterSaveType {
    SaveNew,
    SaveUnder,
    Update,
}

export class DialogSavePredefinedFilterData {
    public constructor(
        public saveType: PredefinedFilterSaveType,
        public predefinedFilter: PredefinedFilter
    ) {}
}
